var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"ctx",staticClass:"ctx",style:({width: ((Math.ceil(_vm.volume*10)) + "px")})})}
var staticRenderFns = []

export { render, staticRenderFns }